<template>
  <div class="page">
    <home-header pageTitle="信息修改"/>
    <div class="wrapBig">
      <div class="Tabs">
        <div class="Title">信息修改</div>
        <div class="tabs">
          <div class="tab" :class="curTab == 0 ? 'active' : ''" @click="tabChange(0)">
            <div class="inner">账号修改<a-icon class="right" type="right" /></div>
          </div>
          <div class="tab" :class="curTab == 1 ? 'active' : ''" @click="tabChange(1)">
            <div class="inner">密码修改<a-icon class="right" type="right" /></div>
          </div>
        </div>
      </div>
      <div class="tabContent">
        <div v-if="curTab == 0">
          <update-account></update-account>
        </div>
        <div v-if="curTab == 1">
          <update-pwd></update-pwd>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";
import UpdatePwd from "./components/updatePwd";
import UpdateAccount from "./components/updateAccount";

export default {
  name: "singUp",
  components: {
    HomeHeader,
    Footer,
    UpdatePwd,
    UpdateAccount,
  },
  data() {
    return {
      curTab: '',
    };
  },
  methods: {
    tabChange(val) {
      this.curTab = val
    }
  },
  mounted() {
    this.curTab = this.$route.query.curTab
  },
}
</script>

<style lang="less" scoped>
.page{
  background-color: #F5F5F5;
}
.wrapBig{
  width: 1200px;
	min-height: 448px;
  margin: 20px auto 24px;
  display: flex;
  justify-content: space-between;
}
.Tabs{
  width: 200px;
  .Title{
    width: 200px;
    height: 56px;
    line-height: 56px;
    background: #2A79FF;
    border-radius: 4px 4px 0 0;
    font-size: 18px;
    color: #FFFFFF;
    text-align: center;
  }
  .tabs{
    background: #fff;
    border-radius: 0 0 4px 4px;
  }
  .tab{
    line-height: 54px;
    color: #666;
    padding: 0 14px 0 16px;
    cursor: pointer;
    .inner{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EAEAEA;
    }
    .right{
      font-size: 12px;
      color: #999;
    }
    &:last-child{
      .inner{
        border: 0;
      }
    }
  }
  .active{
    background: #E5EFFF;
    color: #2A79ff;
    .right{
      color: #2A79ff;
    }
  }
}
.tabContent {
  width: 980px;
	min-height: 448px;
}
.card{
  background-color: #ffffff;
  border-radius: 6px;
}
</style>